import { FunctionComponent, useEffect } from 'react';
import { useWasteStore } from '@waste/store/store';
import { ConfirmationTemplate } from '@templates';
import { useLocation } from 'react-router-dom';
import { RoutesList } from '@waste/routes/Routes';
import { InternalServerErrorTemplate } from '@templates';

export const Confirmation: FunctionComponent = () => {
  const {
    wasteCategory,
    receiveConfirmationEmail,
    confirmation,
    resetAllUploadPhoto,
    resetAllWasteDetails,
    resetYourDetails,
  } = useWasteStore();

  const location = useLocation();

  const handlePopstate = () => {
    if (location.pathname === RoutesList.CONFIRMATION) {
      window.location.href = 'https://www.westminster.gov.uk/';
      localStorage.removeItem('waste-details-storage');
      resetAllUploadPhoto();
      resetAllWasteDetails();
      resetYourDetails();
    }
  };

  useEffect(() => {
    window.addEventListener('popstate', handlePopstate);
  });

  if (confirmation?.case_reference === undefined) {
    return <InternalServerErrorTemplate />;
  }
  window.removeEventListener('popstate', handlePopstate);

  const crmId = sessionStorage.getItem('crmId');
  const isLoggedInUser =
    receiveConfirmationEmail.toLowerCase() === 'yes' &&
    crmId !== null &&
    crmId !== undefined &&
    crmId.length > 0;

  const redirectionLink = isLoggedInUser
    ? 'https://mywestminster.westminster.gov.uk/'
    : 'https://www.westminster.gov.uk/report-it';

  const returnButtonText = isLoggedInUser
    ? 'Return to MyWestminster'
    : 'Return to Report it home';

  const contentTitle = 'What happens next?';
  const contentSubtext = (
    <div className="flex flex-col gap-6 text-[21px]">
      <p>
        You have reported{' '}
        <span className="font-semibold">
          {wasteCategory.replaceAll('_', ' ').substring(0, 1).toUpperCase() +
            wasteCategory
              .replaceAll('_', ' ')
              .substring(1, wasteCategory.length)}
        </span>
      </p>

      <p>
        {`${
          confirmation?.sla_text
            ? `We will review your report within `
            : `We will review your report`
        }`}
        <span className="font-semibold">{confirmation?.sla_text}.</span>
      </p>

      {receiveConfirmationEmail === 'Yes' ? (
        <p>You will receive an email confirmation. Please check your inbox.</p>
      ) : null}

      {isLoggedInUser && (
        <p>
          You can view your report in your{' '}
          <a href="https://mywestminster.westminster.gov.uk/">
            MyWestminster account.
          </a>
        </p>
      )}
    </div>
  );

  const navigationButton = {
    label: returnButtonText,
    isExternalLink: true,
    href: redirectionLink,
  };

  return (
    <ConfirmationTemplate
      reference={confirmation?.case_reference}
      contentTitle={contentTitle}
      contentSubtext={contentSubtext}
      feedbackLink={true}
      button={navigationButton}
    />
  );
};
